import fetchPopulares from "./fetchPopulares";
import cargarTitulos from "./cargarTitulos";
import cargarGeneros from "./cargarGeneros";
import './listenerFiltroTipo';
import './listenerFiltroGeneros';
import './listenerBuscar';
import './paginacion';
import './listenerItems';
import './listenerPopup'

const cargar = async() => {
    // Obtenemos los resultados.
const resultados = await fetchPopulares();
if (resultados) {
		// Los cargamos en el DOM.
		cargarTitulos(resultados);
	}
cargarGeneros('movie');
};

cargar();